import { Typography } from "@mui/material"
import { conversionToDefaultCurrencyHandler } from "../../../utils/methods/currency/conversionRateToDefaultCurrency"
import { currencies, currencyToCurrencySymbolMap } from "../../../utils/constants/currencies";
import { getCommaFormattedNumber } from "../../../utils/methods/stringMethods";

const CurrencyTag = ({
  inputCurrency,
  outputCurrency,
  amount,
  conversionRates,
  defaultCurrency,
  sx = {},
  component,
  addParenthesis = false,
  showCurrencyLabel = false,
  dontShowCurrencyLabel = false
}) => {

  console.log(defaultCurrency, "CurrencyTag");

  return (
    <Typography
      component={component}
      sx={{
        fontSize: "0.85rem",
        opacity: "0.75",
        ...sx
      }}
    >
      {addParenthesis ? (
        `(${outputCurrency && (outputCurrency === currencies.CAD || outputCurrency === currencies.USD) ? `${currencies[currencyToCurrencySymbolMap[outputCurrency]]} ` : ""}${getCommaFormattedNumber(conversionToDefaultCurrencyHandler({
          inputCurrency,
          outputCurrency,
          // defaultCurrency: defaultCurrency || currencies.NGN,
          conversionRates,
          amount
        }))} ${!dontShowCurrencyLabel ? (outputCurrency ? currencies[outputCurrency] : currencies.NGN): ""})`
      ) : (
        `${outputCurrency && (outputCurrency === currencies.CAD || outputCurrency === currencies.USD) ? `${currencies[currencyToCurrencySymbolMap[outputCurrency]]} ` : ""}${getCommaFormattedNumber(conversionToDefaultCurrencyHandler({
        inputCurrency,
        outputCurrency,
        // defaultCurrency: defaultCurrency || currencies.NGN,
        conversionRates,
        amount
      }))} ${!dontShowCurrencyLabel ? (outputCurrency ? currencies[outputCurrency] : currencies.NGN): ""}`)}
    </Typography>
  );
};

export default CurrencyTag;